import { render, staticRenderFns } from "./CollectionCard.vue?vue&type=template&id=bc9b1c54&scoped=true&"
import script from "./CollectionCard.vue?vue&type=script&lang=js&"
export * from "./CollectionCard.vue?vue&type=script&lang=js&"
import style0 from "./CollectionCard.vue?vue&type=style&index=0&id=bc9b1c54&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9b1c54",
  null
  
)

export default component.exports